import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAdditionalCustomerId } from '../../Redux/store/authSlice';
import CustManCards from './CustManCards';
import DeActProfile from './DeActProfile';
import './DeActivate.css';
import warningIcon from '../common/asset1/warning-symbol.svg';

const DeActivate = () => {
  const [formData, setFormData] = useState({ customerId: '' });
  const [showDeActProfile, setShowDeActProfile] = useState(false);
  const [errors, setErrors] = useState({ customerId: '' }); 
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onClickGoBack = () => {
    navigate('/admin/home/viewing-user-profile');
  };

  const handleProceedClick = (e) => {
    e.preventDefault();

   
    if (!formData.customerId) {
      setErrors({ ...errors, customerId: 'Customer ID is mandatory.' });
      //alert('Customer ID is mandatory.');
      return;
    }

 
    dispatch(setAdditionalCustomerId({ customerId: formData.customerId }));
    setShowDeActProfile(true);
    setErrors({}); 
  };

  return (
    <div className="whole-mysave-cont">
      <CustManCards />
      {showDeActProfile ? (
        <DeActProfile />
      ) : (
        <div className="close-use-out">
          <div className="close-use-cont">Deactivate a User Account</div>
          <form>
            <div className="close-form">
              <label>
                Full Name
                <input
                  type="text"
                  name="username"
                  placeholder="Enter User Name or Mobile Number"
                  onChange={handleChange}
                />
              </label>

              <label>
                Customer ID
                <input
                  type="text"
                  name="customerId"
                  placeholder="Enter your ID"
                  value={formData.customerId}
                  onChange={handleChange}
                />
                {errors.customerId && (
                <div className="error-reg-icon-out">
                  <img
                    src={warningIcon}
                    alt="Warning-Icon"
                    className="warning-icon"
                  />
                  <span className="error-register-now">{errors.customerId}</span>
                </div>
              )}
              </label>
           
              
            </div>

            <div className="close-form">
              <label>
                Mobile Number
                <input
                  type="text"
                  name="mobilenumber"
                  placeholder="Enter User Name or Mobile Number"
                  onChange={handleChange}
                />
              </label>

              <label>
                Email (optional)
                <input
                  type="text"
                  name="email"
                  placeholder="Enter your email"
                  onChange={handleChange}
                />
              </label>
            </div>

            <button className="close-proceed" onClick={handleProceedClick}>
              Proceed
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default DeActivate;
